import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e31d781"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slight-margin" }, "/", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slight-margin" }, "/", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_IonItem = _resolveComponent("IonItem")!
  const _component_IonList = _resolveComponent("IonList")!
  const _component_IonMenu = _resolveComponent("IonMenu")!

  return (_openBlock(), _createBlock(_component_IonMenu, { contentId: "content" }, {
    default: _withCtx(() => [
      _createVNode(_component_IonList, {
        style: _normalizeStyle($setup.paddingIfIos)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/acknowledgements"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.bonfire }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Acknowledgements")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/home"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.ellipse }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/community"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.people }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Community")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/my-cards"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.person }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("My Decks"),
                  _hoisted_1,
                  _createTextVNode("Cards")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/liked-cards"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.heart }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Liked Decks"),
                  _hoisted_2,
                  _createTextVNode("Cards")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/quiz"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.school }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Quiz")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/language"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.repeat }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Swap Card Languages")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_IonItem, {
            onClick: $setup.hideMenu,
            routerLink: "/logout"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IonIcon, { icon: $setup.exit }, null, 8, ["icon"]),
              _createVNode(_component_IonLabel, null, {
                default: _withCtx(() => [
                  _createTextVNode("Logout")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}